import React from 'react';
import LazyImage from 'components/UI/LazyImage';
import * as styles from './OfficeCard.module.scss';

export default function OfficeCard({ city, address, phone, category }) {
  return (
    <div className={styles.wrapper}>
      <p className={styles.title}>{city}</p>
      <div className={styles.category}>
        <LazyImage
          className={styles.categoryIcon}
          src={category.icon}
          alt={category.name}
          aria-hidden={true}
        />
        <span>{category.name}</span>
      </div>
      <p className={styles.description}>{address}</p>
      {phone && (
        <a className={styles.link} href={`tel:${phone}`}>
          {phone}
        </a>
      )}
    </div>
  );
}
